import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const parts = (ms) => {
  const m = Math.max(0, Math.floor(ms / 60000));
  return { days: Math.floor(m / 1440), hours: Math.floor((m % 1440) / 60), minutes: m % 60 };
};

export const MoonCountdown = () => {
  const [moonAt, setMoonAt] = useState(null);
  const [nowMs, setNowMs] = useState(Date.now());

  useEffect(() => {
    axios.get(`${API}/moon/next`).then(({ data }) => setMoonAt(new Date(data.full_moon_at))).catch(() => {});
    const id = setInterval(() => setNowMs(Date.now()), 30000);
    return () => clearInterval(id);
  }, []);

  if (!moonAt) return null;
  const left = moonAt.getTime() - nowMs;
  const { days, hours, minutes } = parts(left);
  const date = moonAt.toLocaleDateString(undefined, { weekday: "long", day: "numeric", month: "long" });

  return (
    <div className="moon-countdown" data-testid="moon-countdown">
      <span className="moon-orb" aria-hidden="true" />
      <p className="moon-title">The next full moon rises in</p>
      {left > 0 ? (
        <div className="moon-units" data-testid="moon-countdown-time">
          <span><strong>{days}</strong>days</span>
          <span><strong>{hours}</strong>hours</span>
          <span><strong>{minutes}</strong>minutes</span>
        </div>
      ) : (
        <p className="moon-now" data-testid="moon-countdown-time">The full moon is shining now</p>
      )}
      <p className="moon-sub" data-testid="moon-countdown-date">{date} · your full moon blessing will arrive by email</p>
    </div>
  );
};
